import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { WEB_CONTENT_WIDTH } from '../../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  userWrapper: {
    ...theme.mixins.appClickableContainer,
    padding: theme.spacing(1),
    gap: theme.spacing(1),
    display: 'flex',
    maxWidth: `calc(${WEB_CONTENT_WIDTH} - ${theme.spacing(2)})`,
    marginTop: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      maxWidth: `calc(100vw - ${theme.spacing(2)})`,
    },
  },

  avatarWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  userDetails: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'calc(100% - 64px)',
    height: '100%',
  },

  infoWrapper: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },

  infoName: {
    ...theme.mixins.appEllipsis,
    maxWidth: `calc(100% - 40px)`,
  },

  controlWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: `${theme.spacing(1)} 0`,
  },

  userWrapperAdjacent: {
    marginTop: '8px',
  },
}));
